import { useSearchParams } from "react-router-dom";
export var useDeleteQuery = function () {
    var _a = useSearchParams(), searchParams = _a[0], setSearchParams = _a[1];
    var deleteQuery = function (query) {
        if (!query)
            return;
        if (searchParams.get(query)) {
            searchParams.delete(query);
            setSearchParams(searchParams);
        }
    };
    return { deleteQuery: deleteQuery };
};
